import { getStyles } from './helpers/getStyles'
import adIcon from '../../../assets/iconAd.svg'

const adLogoStyles = {
  height: '10px',
  width: '16px',
  'align-items': 'center',
  'justify-content': 'center',
  position: 'absolute',
  top: '2px',
  right: '5px',
  'line-height': '1'
}

export const adLogo = `<div data-pin-nopin=true style="${getStyles(
  adLogoStyles
)}"><img src=${adIcon} alt='' aria-label='Ad' /> </div>`
